import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  getIfscReqSuccess,
  getIfscReqError,
  ckycConfirmReqError,
  ckycConfirmReqSuccess,
} from "./connectBankAction";
import {
  CKYC_CONFIRMATION_REQUEST,
  FETCH_IFSC_CODE_REQUEST,
  PERSONAL_INFO_REQUEST,
} from "../actionType";
import {
  CONNECT_BANK_FETCH_IFSC,
  INVESTOR_DOCS,
  UPDATE_BANK_DETAILS,
} from "../../../utils/urls";
import { fetchPost, fetchGetIfscCode, fetchGet } from "../../../utils/request";
import {
  getPersonalInfoError,
  getPersonalInfoSuccess,
} from "../PersonalInfo/personalInfoAction";

const stateValueConnectBank = (state: any) => state.connectBank;
const stateNameBank = (state: any) => state.personalInfo;

function* personalInfoReq(): any {
  const stateConnectBank = yield select(stateValueConnectBank);
  const stateAccountName = yield select(stateNameBank);
  try {
    const body = {
      IFSC: stateConnectBank?.kycValue?.ifscCode,
      AccountNumber: stateConnectBank?.kycValue?.accountNumber,
      BankName: stateConnectBank?.ifscData?.BANK,
      BankBranch: stateConnectBank?.ifscData?.BRANCH,
      AccountName: stateAccountName?.tokenReq?.full_name,
    };
    const response = yield call(fetchPost, UPDATE_BANK_DETAILS, body);
    if (response?.status && response?.results) {
      yield put(getPersonalInfoSuccess(response));
      return true;
    }
    if (response.error) {
      yield put(getPersonalInfoError(response.error));
      return false;
    }
  } catch (error) {
    yield put(getPersonalInfoError("Internal Server Error"));
  }
}

function* fetchIfscData(): any {
  const stateName = yield select(stateValueConnectBank);
  try {
    if (stateName?.ifscValue) {
      const response = yield call(
        fetchGetIfscCode,
        CONNECT_BANK_FETCH_IFSC + stateName?.ifscValue
      );
      yield put(getIfscReqSuccess(response));
    }
  } catch (error) {
    yield put(getIfscReqError(error));
  }
}

function* getCkycReq(): any {
  try {
    const response = yield call(fetchGet, INVESTOR_DOCS);
    if (response && (response.error || !response.status)) {
      const responseTemp: any = {
        status: true,
      };
      yield put(ckycConfirmReqSuccess(responseTemp));
      return true;
    }
    if (response.error) {
      yield put(ckycConfirmReqError(response.error));
      return false;
    }
    if (response.status) {
      yield put(ckycConfirmReqSuccess(response));
      return true;
    }
  } catch (error) {
    yield put(ckycConfirmReqError(error));
  }
}

export default function* sagaConnectBank() {
  yield all([
    takeLatest(PERSONAL_INFO_REQUEST, personalInfoReq),
    takeLatest(FETCH_IFSC_CODE_REQUEST, fetchIfscData),
    takeLatest(CKYC_CONFIRMATION_REQUEST, getCkycReq),
  ]);
}
